import type { SupabaseClient } from '../client'
import type { Database } from '../database.types'
import { unwrapList } from './_helpers'

export type DocumentRow = Database['portal']['Tables']['documents']['Row']

const DOCUMENT_COLUMNS =
  'id, project_id, initiative_id, doc_type, title, content, published, published_at, published_by, sort_order, created_at, updated_at'

/**
 * Lista documents publicados de um projeto por tipo.
 * Usado em "Releases" (doc_type='release_notes').
 */
export async function listPublishedDocuments(
  client: SupabaseClient,
  projectId: number,
  docType: string,
): Promise<DocumentRow[]> {
  const result = await client
    .schema('portal')
    .from('documents')
    .select(DOCUMENT_COLUMNS)
    .eq('project_id', projectId)
    .eq('doc_type', docType)
    .eq('published', true)
    .order('published_at', { ascending: false })

  return unwrapList(result) as unknown as DocumentRow[]
}

/**
 * Lista TODOS os documents publicados de um projeto, opcionalmente filtrando
 * por uma lista de tipos. Usado pra exibir Entregas no portal (que cobre
 * release_notes + test_guide + presentation + general).
 */
export async function listAllPublishedDocuments(
  client: SupabaseClient,
  projectId: number,
  docTypes?: string[],
): Promise<DocumentRow[]> {
  let query = client
    .schema('portal')
    .from('documents')
    .select(DOCUMENT_COLUMNS)
    .eq('project_id', projectId)
    .eq('published', true)
    .order('published_at', { ascending: false })

  if (docTypes && docTypes.length > 0) {
    query = query.in('doc_type', docTypes)
  }

  return unwrapList(await query) as unknown as DocumentRow[]
}
